import { ArenaOpsUsdtSchema } from "./arena-ops-filters.dto";
import { z } from "zod";

export const ArenaOpsBalanceBandSchema = z.object({
  label: z.string(),
  lowerUsdt: ArenaOpsUsdtSchema,
  /** null on the open-ended top band. */
  upperUsdt: ArenaOpsUsdtSchema.nullable(),
  accountCount: z.number().int(),
  totalUsdt: ArenaOpsUsdtSchema,
});

export const ArenaOpsUsersBalanceDistributionResponseSchema = z.object({
  bands: z.array(ArenaOpsBalanceBandSchema),
  accountCount: z.number().int(),
  totalUsdt: ArenaOpsUsdtSchema,
});
export type ArenaOpsUsersBalanceDistributionResponse = z.infer<typeof ArenaOpsUsersBalanceDistributionResponseSchema>;
